/**
 * -----------------------------------------------------
 * References
 * ------------------------------------------------------
 * [Polling in React using the useInterval Custom Hook](https://blog.bitsrc.io/polling-in-react-using-the-useinterval-custom-hook-e2bcefda4197)
 * [Making setInterval Declarative with React Hooks](https://overreacted.io/making-setinterval-declarative-with-react-hooks/)
 *
 */

import { useEffect, useRef } from 'react';

export default function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
